import React from 'react';
import { View, Image, ScrollView } from 'react-native';
import Label from '../../common/Label';
import useTranslation from '../../../hooks/translation-hook';
import CustomMarkdown from '../../common/CustomMarkDown';
import useCustomTheme from '../../../hooks/theme-hook';
import { getOnboardingPalette } from '../onboardingPalette';

const OnboardingMobileTwo = () => {
  const t = useTranslation({ defaultPath: 'onboarding.page2' });
  const theme = useCustomTheme();
  const palette = getOnboardingPalette(1, !!theme.isDark);
  return (
    <View style={{ flexGrow: 1, backgroundColor: palette.backgroundColor }}>
      <Image {...({ pointerEvents: 'none' } as any)} source={require('../../../../assets/onBoarding_mobile_2.png')} style={{ aspectRatio: '350/234', width: '100%', height: 'auto' }} />
      <View style={{ flexGrow: 1, marginTop: 8 }}>
        <ScrollView
          style={{ flex: 1 }}
          contentContainerStyle={{ flexGrow: 1, paddingLeft: 12, paddingRight: 12, paddingBottom: 42 }}
          scrollEnabled={true}
          showsVerticalScrollIndicator={true}
          nestedScrollEnabled={true}
          bounces={false}
          overScrollMode="never"
        >
          <View style={{ width: '100%' }}>
            <Label style={{ fontSize: 28, color: palette.titleColor, fontWeight: '600', width: 250 }} numberOfLines={20}>
              {t('title')}
            </Label>
            <Label style={{ marginTop: 20, fontSize: 18, color: palette.subtitleColor, fontWeight: '400', width: 250 }} numberOfLines={20}>
              {t('subtitle')}
            </Label>
            <View style={{ marginTop: 16 }}>
              <CustomMarkdown
                style={{
                  body: { fontSize: 15, color: palette.bodyColor, marginTop: 0, marginBottom: 0 },
                  paragraph: { marginTop: 0, marginBottom: 8 },
                  ordered_list: { marginTop: 0, marginBottom: 0, paddingLeft: 0 },
                  list_item: { marginTop: 4, marginBottom: 0 },
                  ordered_list_icon: { marginLeft: 0, marginRight: 6, color: palette.bodyColor },
                  ordered_list_content: { marginTop: 0, flex: 1 },
                }}
              >
                {t('description')}
              </CustomMarkdown>
            </View>
          </View>
        </ScrollView>
      </View>
    </View>
  );
};

export default OnboardingMobileTwo;
